// Local development hosts: *.local (one per shop, e.g. elna.jpujol.local),
// localhost and 127.0.0.1. Only there the front calls the local API and
// honours the SHOP and FORCED_IP overrides (ADR-0061).
export const isLocalHost = (hostname) =>
  /\.local$/.test(hostname) || hostname === 'localhost' || hostname === '127.0.0.1'

export const isLocal = () => isLocalHost(window.location.hostname)

const warned = new Set()

// console.warn once per page load, for the local overrides
export const warnOnce = (message) => {
  if (warned.has(message)) return
  warned.add(message)
  console.warn(message)
}

export const resetWarnings = () => warned.clear()
